import React, { createContext, useContext, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateUserCurrencies } from 'redux/slices/systemSlice';
import { GET_USER_CURRENCIES } from '../constants/aryGraphqlSchemas';
import { useAryLazyQuery } from '../hooks/useAryGraphql';

const ShowCurrenciesContext = createContext();

function ShowCurrenciesContextProvider({ children }) {
  const dispatch = useDispatch();
  const doGetUserCurrencies = useSelector(
    (state) => state.systemReducer.doGetUserCurrencies
  );
  const [getUserCurrencies, { data: getUserCurrenciesData }] = useAryLazyQuery({
    gqlConfig: GET_USER_CURRENCIES,
    items: `
      code
      title
      decimalPlaces
    `
  });
  useEffect(() => {
    if (doGetUserCurrencies) {
      getUserCurrencies();
    }
  }, [doGetUserCurrencies]);
  useEffect(() => {
    if (getUserCurrenciesData) {
      dispatch(updateUserCurrencies(false));
    }
  }, [getUserCurrenciesData]);
  return (
    <ShowCurrenciesContext.Provider value={getUserCurrenciesData}>
      {children}
    </ShowCurrenciesContext.Provider>
  );
}

export const useShowCurrenciesContext = () => useContext(ShowCurrenciesContext);
export default ShowCurrenciesContextProvider;
